export class NativeStreamSpoolConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "groupKeyRegex",
            "baseName": "groupKeyRegex",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamSpoolConfig.attributeTypeMap;
    }
    constructor() {
    }
}
